import { useAuth } from '@features/auth/hooks/useAuth';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { auth } from '../../config/firebase';
import { ImageService, ImageType } from '../services/image.service';
import { getProfileQueryKey } from './useProfile';

interface UseImageUploadOptions {
  type: ImageType;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useImageUpload = (options: UseImageUploadOptions) => {
  const [isUploading, setIsUploading] = useState(false);
  const queryClient = useQueryClient();

  const { isAuthenticated } = useAuth();

  const { mutateAsync: uploadImage } = useMutation({
    mutationFn: async (file: File) => {
      setIsUploading(true);
      try {
        if (!isAuthenticated) throw new Error('User not authenticated');

        const userId = auth.currentUser?.uid;
        console.log('User ID:', auth.currentUser);
        if (!userId) throw new Error('User not authenticated');

        return await ImageService.uploadImage({
          file,
          type: options.type,
          userId
        });
      } finally {
        setIsUploading(false);
      }
    },
    onSuccess: () => {
      // Invalidate profile query to refresh data
      queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
      options.onSuccess?.();
    },
    onError: (error) => {
      console.error('Error uploading image:', error);
      options.onError?.(error);
    }
  });

  return {
    uploadImage,
    isUploading
  };
};
